module.exports = __webpack_public_path__ + "img/share.37755f6e.png";